import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const ResourceGroup = lazy(() =>
    import('@/v1/auth/views/ResourceGroup').then((module) => ({
        default: module.ResourceGroup,
    }))
);

const Resource = lazy(() =>
    import('@/v1/auth/views/Resource').then((module) => ({
        default: module.Resource,
    }))
);

const ResourceAction = lazy(() =>
    import('@/v1/auth/views/ResourceAction').then((module) => ({
        default: module.ResourceAction,
    }))
);

export const resourceSettingRoutes: RouteObject[] = [
    {
        path: `resource_group/:mode?`,
        ...PageElement(<ResourceGroup />),
    },
    {
        path: `resource`,
        ...PageElement(<Resource />),
    },
    {
        path: `action`,
        ...PageElement(<ResourceAction />),
    },
];
